import { Injectable } from "@angular/core";
import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";
import { RoofareaModelView } from "../../../public-api";

@Injectable({
    providedIn: 'root'
})
export class RoofareaViewService extends RestReadServiceBase<RoofareaModelView> {
    constructor(
    ) {
        super("RoofareaModelView", false);
    }
}